<div class="message-template__container">
  <p>{{ 'messenger.templates_description_l' | translate }}</p>
  @let isLoading = processingAction$ | async;
  <button
    im-button
    class="primary d-inline-flex mt10 mb10"
    [disabled]="isLoading"
    (click)="createTemplate()"
  >
    @if (isLoading) {
      <im-spinner iconStart class="sm" />
    }
    {{ 'messenger.create_template_a' | translate }}
  </button>
  @if (showCreateTemplate) {
    <div class="messenger-template__create-container">
      <app-message-template-form
        [activeTemplate]="activeTemplate"
        [conversationMessageTemplateSubstitutionTags]="
          conversationMessageTemplateSubstitutionTags()
        "
        (saveTemplate)="saveTemplate($event)"
      >
        <button
          im-button
          class="inverted mr10"
          cancel-button
          (click)="cancelCreate()"
        >
          {{ 'CANCEL_A' | translate }}
        </button>
      </app-message-template-form>
    </div>
  }
  <div class="messenger-template__scroll-container">
    @if (!(loadedTemplatesActionState$ | async)?.pending) {
      <im-accordion class="messenger-template__accordion">
        @for (template of templates; track template.id; let i = $index) {
          <ng-container
            imAccordionItem
            (openedChange)="panelChanged($event, i)"
          >
            <span
              *imAccordionHeader
              class="d-flex justify-content-between align-items-center"
            >
              <span class="title">{{ template.title }}</span>
              <button
                im-icon-button
                class="ms-2"
                [disabled]="
                  (createActionState$ | async)?.pending ||
                  (updateActionState$ | async).pending ||
                  (deleteActionState$ | async).pending
                "
                [attr.aria-label]="'general.delete_l' | translate"
                (click)="deleteTemplate($event, template?.id, i)"
              >
                <i class="icon icon--remove" aria-hidden="true"></i>
              </button>
            </span>
            <ng-container *imAccordionContent>
              <!-- im-accordion renders every item's content up front; only
                   build the form for the template that is being edited -->
              @if (activeTemplate === template) {
                <app-message-template-form
                  [activeTemplate]="activeTemplate"
                  [conversationMessageTemplateSubstitutionTags]="
                    conversationMessageTemplateSubstitutionTags()
                  "
                  (saveTemplate)="saveTemplate($event)"
                ></app-message-template-form>
              }
            </ng-container>
          </ng-container>
        }
      </im-accordion>
    } @else {
      <div class="loading-area">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }
  </div>
  <im-pagination
    class="d-block mt15"
    [page]="loadedTemplatePagination?.page ?? 0"
    [pageSize]="loadedTemplatePagination?.size"
    [totalCount]="loadedTemplatePagination?.totalElements ?? 0"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onSizeChange($event)"
  ></im-pagination>
</div>
<ng-template #loading>
  <div class="loading-area">
    <app-loading-spinner></app-loading-spinner>
  </div>
</ng-template>
